// ADMINS
const adminList = [
    'mbayne@tcelect.net',
    'jshavel@tcelect.net',
    'pbesser@tcelect.net',
    'roneill@tcelect.net',
    'sdefalco@tcelect.net',
    'ckruger@tcelect.net',
    'chowley@tcelect.net'
]

//TOOLS
const toolList = [
    'Email Generator',
    'Chatbot',
    'Cable Run Optimizer',
    'GO Tracker',
    'Tool Usage Statistics',
    'Drone Captures',
    'EIT Dashboard',
    'Training',
    'Executive Dashboards',
    'Monthly Executive Reports'
]

module.exports = {
    adminList, 
    toolList
}


